import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { JsonMapperService } from '../../../../core/services/mapper/mapper.service';
import { OperateursService } from '../../../intervenant/services/operateurs/operateurs.service';
import { ReferencesService } from '../../../intervenant/services/references/references.service';
import { Adresse } from '../../models/adresse.model';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AdressesService {
    constructor(
        private readonly http: HttpClient,
        private readonly mapper: JsonMapperService,
        private readonly operateursService: OperateursService,
        private readonly refService: ReferencesService
    ) {}

    /**
     * Ajouter une adresse pour un juré
     * @param idJure - Juré id
     * @param adresse - Adresse infos
     */
    createAdresseJure(idJure: number, adresse: Adresse): Observable<void> {
        return this.http.post<void>(`/api/declaration/private/jures/${idJure}/adresses`, adresse);
    }

    /**
     * Récupère les adresses d'un juré
     * @param idJure - Juré id
     */
    getAdressesJure(idJure: number): Observable<Adresse[]> {
        return this.http.get<Adresse[]>(`/api/declaration/private/jures/${idJure}/adresses`);
    }

    /**
     * Met à jour l'adresse d'un juré
     * @param idJure - Juré id
     * @param adresse -  Adresse infos
     */
    updateAdresseJure(idJure: number, adresse: Adresse): Observable<void> {
        return this.http.put<void>(`/api/declaration/private/jures/${idJure}/adresses`, adresse);
    }
}
